import {
  faBell,
  faEgg,
  faEnvelope,
  faRightToBracket,
} from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { isEasterToday } from '../../../common/isEaster';
import Action from '../../Action';
import Button from '../../Atoms/Button';
import Logo from '../../Atoms/Logo';
import UserPicture from '../../Atoms/UserPicture';
import faDynamicEarth from '../../Icons/faDynamicEarth';
import HeaderNavActions from '../HeaderNavActions';
import UserMenu from '../UserMenu';

import * as style from './style.module.css';

const HeaderNavigation = ({
  t,
  className = '',
  contest = null,
  contestsToJudge = [],
  user = null,
  allowedActions = [],
  unreadChats = 0,
  unreadNotifications = 0,
  easterGameScore = null,
  loading = false,
  darkModeStatus = 'LIGHT',
  onSignOut = () => { },
  onLanguageChange = () => { },
  onThemeChange = () => { }
}) => {
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const navigate = useNavigate();

  return (<>
    <div className={`${style.container} ${className}`}>
      <div className={style.left}>
        <Action action="/" title={t('Home')}>
          <Logo className={style.logo} />
        </Action>
      </div>
      <div className={style.center}>
        <HeaderNavActions contest={contest} user={user} unreadChats={unreadChats} unreadNotifications={unreadNotifications} />
      </div>
      <div className={style.right}>
        {!loading && user && (
          <>
            <UserPicture {...user} title={t('User profile')} className={style.user} animatedPicture={null} action={() => setIsMenuOpened(true)} />
            <Button className={style.actionNotif} action={`/chats/`} title={t('Chats')} floatingHint={unreadChats} icon={faEnvelope} />
            <Button className={style.actionNotif} action={() => navigate(`/notifications/?t=${new Date().getTime()}`)} floatingHint={unreadNotifications} icon={faBell} />
            {isEasterToday() && <Button className={style.actionNotif} action={`/easter/${new Date().getFullYear()}`} floatingHint={easterGameScore || t('?')} floatingHintColor="INFO" icon={faEgg} />}
          </>
        )}
        {!loading && !user && (
          <Button className={style.signInButton} action="/sign-in/" label={t('Sign in')} icon={faRightToBracket} />
        )}
        {!user && <Button className={style.actionNotif} icon={faDynamicEarth} title={t('Language')} action={onLanguageChange} />}
      </div>
    </div>
    {user && <UserMenu contestsToJudge={contestsToJudge} onLanguageChange={onLanguageChange} onThemeChange={onThemeChange} darkModeStatus={darkModeStatus} allowedActions={allowedActions} isOpened={isMenuOpened} onClose={() => setIsMenuOpened(false)} onSignOut={onSignOut} user={user} />}
  </>
  );
};

export default withTranslation()(HeaderNavigation);

HeaderNavigation.propTypes = {
  t: PropTypes.func,
};
